<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer005" role="doc-foreword">
<p class="pl-epigraph">Instead of shame and dishonor, you will enjoy a double share of honor. You will possess a double portion of prosperity in your land, and everlasting joy will be yours.</p>
<p class="pl-citation">—<em class="italic">Isaiah </em>61:7</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bible_Verse.vue?debb9f60